import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { RegistrationService } from '../services/registration.service';

import { Customer } from '../models/Customer';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-set-pass',
  templateUrl: './set-pass.component.html',
  styleUrls: ['./set-pass.component.css']
})
export class SetPassComponent implements OnInit {

  customer: Customer;
  retypePassword: string;
  termsAccepted: boolean;
  orgUnitId: string;
  userExists = false;
  submitting = false;

  constructor(
    private service: RegistrationService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private loginservice: LoginService
  ) {
    this.customer = {
      username: '',
      password: '',
      email: '',
      accountNumber: '',
      accountId: '',
      customerUUID: '',
      webAccessCode: '',
      firstName: '',
      lastName: '',
      lastFourSSN: '',
      zipCode: 0,
      orgUnitId: '',
      userId: '',
      id: '',
      UserUUID: ''
    };
  }

  ngOnInit() {
    //this.getOrgUnitId();
  }

  onCancel() {
    this.router.navigate(['/Login']);
  }

  onBack() {
    this.router.navigate(['/About']);
  }

  onSubmitClick() {
    if (this.submitting) {
      return;
    }
    this.spinnerService.show();
    this.submitting = true;
    let newCustomer: Customer = {
      accountNumber: this.customer.accountNumber,
      accountId: this.customer.accountId,
      customerUUID: this.customer.customerUUID,
      webAccessCode: this.customer.webAccessCode,
      username: this.customer.username,
      password: this.customer.password,
      email: this.customer.email,
      firstName: this.customer.firstName,
      lastName: this.customer.lastName,
      lastFourSSN: this.customer.lastFourSSN,
      zipCode: this.customer.zipCode,
      orgUnitId: this.customer.orgUnitId,
      userId: this.customer.userId,
      id: this.customer.id,
      UserUUID: this.customer.UserUUID,
    };

    this.getOrgUnitId(newCustomer);
    this.getFirstAndLastNames(newCustomer);
    this.getCustomerEmail(newCustomer);

    this.service.createUser(newCustomer)
      .subscribe((res: any) => {
        if (res.success) {
          //newCustomer.userId = res.res.userId;
          newCustomer.id = res.res.id;
          newCustomer.UserUUID = res.res.userUUId;
          this.getCustomerUUID(newCustomer);
          this.router.navigate(['/Login']);
          //this.loginservice.login(newCustomer.username, newCustomer.password)
          //  .subscribe((res: any) => {
          //    if (res.success) {
          //      //this.loginservice.setUserContextDetail(res.modelRet);
          //      this.spinnerService.hide();
          //      this.submitting = false;
          //      this.router.navigate(['/login']);
          //    } else {
          //      this.spinnerService.hide();
          //    }
          //  });
          //this.mapCustomerToUser(newCustomer);
        } else {
          this.userExists = true;
          this.spinnerService.hide();
        }
      });
  }

  mapCustomerToUser(newCustomer: Customer) {
    this.spinnerService.show();
    this.service.mapUserCustomer(newCustomer)
      .subscribe((res: any) => {
        if (res.success) {
          this.loginservice.login(newCustomer.username, newCustomer.password)
            .subscribe((res: any) => {
              if (res.success) {
                this.loginservice.setUserContextDetail(res.modelRet);
                this.spinnerService.hide();
                this.submitting = false;
                this.router.navigate(['/Billing/Usage']);
              } else {
                this.spinnerService.hide();
              }
            });
        } else {
          this.userExists = true;
          this.spinnerService.hide();
        }
      });

  }

  getOrgUnitId(customer: Customer) {
    this.service.orgUnitId.subscribe(orgUnitId => customer.orgUnitId = orgUnitId);
  }

  getCustomerUUID(customer: Customer) {
    this.service.customerUUID.subscribe(custUuid => customer.customerUUID = custUuid);
  }

  getCustomerEmail(customer: Customer) {
    this.service.email.subscribe(email => customer.email = email);
  }

  //getCustomerId(customer: Customer) {
  //  this.service.customerUUID.subscribe(custId => customer.customerUUID = custId);
  //}

  getFirstAndLastNames(customer: Customer) {
    this.service.firstName.subscribe(fName => customer.firstName = fName);
    this.service.lastName.subscribe(lName => customer.lastName = lName);
  }

}



// WEBPACK FOOTER //
// ./src/app/set-pass/set-pass.component.ts